import './reset.css';
import { Tree } from './Tree';
import { NodeExpansionSetContextProvider } from '../contexts/NodeExpansionSet';
import { TreeContextProvider } from '../contexts/TreeContext';
import { useEffect, useRef, useState } from 'react';
import { TreeNodeData } from '../model';
import { TreeStore } from '../store';

export function App() {
  const [tree, setTree] = useState<TreeNodeData | null>(null);
  const open = useRef<boolean>(true);

  useEffect(() => {
    async function read() {
      let data = await TreeStore.retreive();
      if (!data) {
        const new_data: TreeNodeData = {
          id: 0,
          text: '',
          children: [
            {
              id: 1,
              text: 'Welcome!',
              children: [],
            },
          ],
        };

        await TreeStore.update(new_data).promise;
        data = new_data;
      }

      if (open.current) {
        setTree(data);
      }
    }

    read();

    return () => {
      open.current = false;
    };
  }, []);

  return tree ? (
    <TreeContextProvider initialData={tree}>
      <NodeExpansionSetContextProvider>
        <div>
          <main>
            <Tree />
          </main>
        </div>
      </NodeExpansionSetContextProvider>
    </TreeContextProvider>
  ) : (
    'Loading...'
  );
}

// useEffect(() => {
//   fetch(
//     'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/nzd.json',
//   )
//     .then((v) => {
//       if (!v.ok) {
//         throw v;
//       }

//       const r = v.json();
//     })
//     .catch((x) => {
//       if (x instanceof Error) {
//         console.error(`Network request failed`, x);
//       } else {
//         console.error(`Bad Response []`, x);
//       }
//     });
// });
